import {
  createSelector,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import store from 'store';

import type { GetMonitorsRequestQuery } from 'api/endpoints/monitors/monitors.types';

import 'store/configureRTK';

type MonitorsStore = {
  filters: GetMonitorsRequestQuery;
};

export const initialFilters: GetMonitorsRequestQuery = {
  sort: 'last_change_at',
  limit: 20,
  hasChanged: true,
  startDate: new Date(2000, 1, 1),
  page: 1,
};

const initialState: MonitorsStore = {
  filters: {
    ...initialFilters,
  },
};

const monitorsView = createSlice({
  name: 'monitorsView',
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<Partial<GetMonitorsRequestQuery>>) {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
});

store.addModel({
  name: 'monitorsView',
  state: monitorsView.getInitialState(),
  reducers: {},
  baseReducer: monitorsView.reducer,
});

const selectSelf = createSelector(
  [(state: { monitors: MonitorsStore }) => state.monitors],
  (monitors) => monitors,
);

const selectFilters = createSelector(
  [selectSelf],
  (monitors) => monitors.filters,
);

export const useMonitorsFilters = () =>
  useSelector<{ monitors: MonitorsStore }, GetMonitorsRequestQuery>(
    selectFilters,
  );

export const setMonitorsFilters = (filters: Partial<GetMonitorsRequestQuery>) =>
  store.dispatch(monitorsView.actions.setFilter(filters));

export default monitorsView;
